import React, { useState, FormEvent, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { Suggest2, ItemRenderer, ItemPredicate } from '@blueprintjs/select';
import { MultiSelect2} from "@blueprintjs/select";
import { FormGroup, InputGroup, AnchorButton, Button, Tabs, Tab, Collapse, HTMLSelect, HTMLTable, ControlGroup, NumericInput, TextArea, Position, Toaster, Intent, MenuItem } from "@blueprintjs/core";
import { Radio, RadioGroup, Switch, Alert, Checkbox, Tooltip, ProgressBar } from "@blueprintjs/core";
import { H2, H3, H4, H5, H6 } from "@blueprintjs/core";
import { Classes, Card, Elevation } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";



import { AxiosInstance } from 'axios';

import * as utils from "../utils";

import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form'

import svgWait2 from '../svg/wait2.gif'


import { FBSOpenPosInfo } from '../Types'
import { SystemHeader, FBSClientPicker } from '../CommonUI';

import i18next from 'i18next';

interface PageInfo {
    n: number
}

var GsbFlag: any;


interface PositionMakeupMainProps {
    gsb: AxiosInstance
}

const toaster = Toaster.create({
    position: Position.TOP,
})

function PositionMakeupMain({ gsb }: PositionMakeupMainProps) {

    const { register, handleSubmit, reset, setValue, setError, errors } = useForm<FBSOpenPosInfo>()
    const { t, i18n } = useTranslation();    

    let url = document.location.toString()
    let qString = url.substr(url.indexOf("?"))
    
    //let Groupid = ""
    let Groupid = utils.getUrlParameter('Groupid', url); 
    let { Groupid: defaultSearchValue = "" }: { Groupid: string } = useParams()

    let ProgressId2 = ""
    
    const imgWait = <img className="WaitIcon" src={svgWait2} alt="wait" />
    const coLogo = <img className="coLogo" src="coLogo.gif" alt="Co Logo" />

    const [Data, setData] = useState([] as FBSOpenPosInfo[])


    const [searchKey, setSearchKey] = useState("OpenDate")
    const [searchValue, setSearchValue] = useState("")

    const [showFilters, setShowFilters] = useState(false)
    const [showButton, setshowButton] = useState(false)


    const [ProgressId, setProgressId] = useState("")
    const [ProgressValue, setProgressValue] = useState(0)

    const [nPage, setnPage] = useState(0)
    const [nTotalPage, setnTotalPage] = useState(0)
    const [aPageNumber, setaPageNumber] = useState([] as PageInfo[])
    const [MoblieDev, setMoblieDev] = useState(false)

    const [currentAc, setCurrentAc] = useState({} as FBSOpenPosInfo)
    const [BlankAc, setBlankAc] = useState({} as FBSOpenPosInfo)

    const [CurrentMode, setCurrentMode] = useState("show")

    const [ShowWait, setShowWait] = useState(false)
    const [ShowRst, setShowRst] = useState(false)
    const [ShowNoRecord, setShowNoRecord] = useState(false)
    const [ShowOK, setShowOK] = useState(true)

    const [s_AcCodeValue, sets_AcCodeValue] = useState("")
    const [isClPickerOpen, setIsClPickerOpen] = useState(false)
    const [AcName1Value, setAcName1Value] = useState("")
    const [AcName2Value, setAcName2Value] = useState("")
    const [s_ComdyValue, sets_ComdyValue] = useState("")
    const [ComdyNameValue, setComdyNameValue] = useState("")
    const [MarketValue, setMarketValue] = useState("")
    const [s_DMonValue, sets_DMonValue] = useState("")
    const [s_CallPutValue, sets_CallPutValue] = useState("")
    const [s_StrikePriceValue, sets_StrikePriceValue] = useState("")

    const [CO_NAME, setCO_NAME] = useState("")
    const [companyLogoName, setcompanyLogoName] = useState("")
    const [SBPath, setSBPath] = useState("")
    const [TRAN_DATE, setTRAN_DATE] = useState(utils.formatNumber(new Date()))
    const [SETL_DATE, setSETL_DATE] = useState(utils.formatNumber(new Date()))
    const [userKey, setuserKey] = useState("")
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")
    const [Enter2tab, setEnter2tab] = useState("Y")

    //gsb default value


    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                //console.log("PositionMakeupMain disp user_key: ", res.data.Flag.user_key)
                //console.log("PositionMakeupMain disp MULTI_MKT: ", res.data.Flag.MULTI_MKT)
                //console.log("PositionMakeupMain disp data.Flag: ", res.data.Flag)
                GsbFlag = res.data.Flag;
                //console.log("PositionMakeupMain disp GsbFlag: ", GsbFlag)
                //console.log("PositionMakeupMain disp GsbFlag.lang: ", GsbFlag.lang)
                //console.log("PositionMakeupMain disp GsbFlag.dateFormat: ", GsbFlag.dateFormat)
                console.log("GsbFlag.user_key: ", GsbFlag.user_key)
                //console.log("GsbFlag.UserID: ", GsbFlag.UserID)
                //console.log("PositionMakeupMain disp GsbFlag.MULTI_MKT: ", sbFlag.MULTI_MKT)
                //console.log("PositionMakeupMain disp GsbFlag.MGNGP_USER: ", GsbFlag.MGNGP_USER)
                //console.log("PositionMakeupMain disp GsbFlag.CO_NAME: ", GsbFlag.CO_NAME)
                setCO_NAME( GsbFlag.CO_NAME) ;
                setcompanyLogoName( GsbFlag.companyLogoName) ;
                setSBPath( GsbFlag.SBPath) ;
                setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                setSETL_DATE(GsbFlag.SETL_DATE ) ;
                setuserKey(GsbFlag.user_key) ;
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }
                setEnter2tab(GsbFlag.Enter2tab) ;

            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])



    useEffect(() => {
        if ( Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [])


    let acNoLength = 12

    useEffect(() => {
        setShowRst(false)
        setShowNoRecord(false)
        setshowButton(false)
        setShowOK(true)
    }, [s_AcCodeValue, s_ComdyValue, s_DMonValue, s_CallPutValue, s_StrikePriceValue])


    useEffect(() => {
        const refreshTasks = async () => {
            ProgressId2 = ProgressId
            //console.log("Progresslist ProgressId: ", ProgressId2) 
            if ( ProgressId2.trim().length > 0 ) {
                try {
                    const res = await gsb.post('/Progresslist', {p_data: ProgressId2})
                    let pValue = 0
                    if ( res.data.count > 0 ) {
                        if ( res.data.data[0].id === ProgressId2 ) {
                            pValue = res.data.data[0].progressValue / res.data.data[0].progressMax
                            //console.log("Progresslist: ", res.data.data[0].progressValue, res.data.data[0].progressMax) 
                            //console.log("Progresslist pValue: ", pValue) 
                            setProgressValue(pValue)
                        }
                        if (res.data.data[0].status > 0 ) {
                            clearInterval(timer)
                        }
                    }
                } catch (error) {
                    utils.showError(error)
                }
            }
        }
        let timer = setInterval(refreshTasks, 1*1000)
        return () => {clearInterval(timer)}
    }, [gsb, ProgressId, nPage])

    useEffect(() => {
        (async () => {
            try {
                // get AC Info
                const res = await gsb.post('/fbs/Master', {sb_data: "", cPgmId: "CLMast", cAction: "GetCLInfo", cAcct: s_AcCodeValue})
                
                if ( s_AcCodeValue.trim().length > 0 && res.data.count > 0 )
                {
                    setAcName1Value(res.data.data[0].d_Name)
                    setAcName2Value(res.data.data[0].d_Name2)
                    // setCommCodeValue(res.data.data[0].d_CommCode)
                } else { 
                    setAcName1Value("")
                    setAcName2Value("")
                    // setCommCodeValue("")
                }
            
            } catch (error) {
                //showErrorBox(error)
            }
        })()

    }, [gsb, s_AcCodeValue])

    useEffect(() => {
        (async () => {
            try {
                const res = await gsb.post('/fbs/Master', {sb_data: "", cPgmId: "ComdyMast", cAction: "GetComdyInfo", cComdy: s_ComdyValue})
                
                if ( s_ComdyValue.trim().length > 0 && res.data.count > 0 )
                {
                    setComdyNameValue(res.data.data[0].d_ComdyName)
                    setMarketValue(res.data.data[0].d_Market)

                } else { 
                    setComdyNameValue("")
                    setMarketValue("")
                }
               
            } catch (error) {
                //showErrorBox(error)
            }
        })()
    }, [gsb, s_ComdyValue])

    const onSubmit = async (e: FormEvent) => {
        e.preventDefault()

        sets_AcCodeValue(s_AcCodeValue.toUpperCase());

        setShowOK(false)
        setshowButton(false)
        setShowWait(true)
        setShowNoRecord(false)
        setShowRst(false)
        setData([])
        ProgressId2 = utils.genUUID()
        setProgressId(ProgressId2)
        setProgressValue(0)

        if ( utils.getDeviceType()) {
            setMoblieDev(true)
        } else {
            setMoblieDev(false)
        }

        setError("d_disp_Error_msg", {message: ""});
        
        (async () => {
            try {
                //console.log("SmMastMain onsubmit called", data)
                const res = await gsb.post('/fbs/Master',
                    {   sb_data: {
                            ProgressId: ProgressId2,
                            s_AcCodeValue: s_AcCodeValue,
                            s_ComdyValue: s_ComdyValue,
                            s_DMonValue: s_DMonValue,
                            s_CallPutValue: s_CallPutValue,
                            s_StrikePriceValue: s_StrikePriceValue,
                        },
                        cPgmId: "OpenPos",
                        cAction: "GetPositionMakeupInfo",
                    });

                console.log("res.data.data: ", res.data.data) 
                if ( res.data.count > 0 ) {
                    setShowWait(false)
                    setShowNoRecord(false)
                    setShowRst(true)
                    setData(res.data.data)
                    setshowButton(true)
                } else {
                    setShowWait(false)
                    setShowNoRecord(true)
                    setShowRst(false)
                }
            } catch (error) {
                utils.showError(error)
                setShowWait(false)
                setShowRst(false)
        }
        })()
        setError("d_disp_Error_msg", {message: ""});
    }



    const onChangeMakeUpQty = (Rec_No: number, MakeUpQty: string) => {
        if (Rec_No > 0 ) {
            console.log("onChangeMakeUpQty Qty", Rec_No, MakeUpQty);

            let newData = [...Data]

            for (let j = 0; j < newData.length; j++) {
                if ( newData[j]._recordNo == Rec_No ) {
                    newData[j].d_MkQty = MakeUpQty
                    break
                }
            }
            setData(newData);
            setshowButton(true)
            //console.log("onChangeMakeUpQty data", Data);

        }
    }


    const onMakeUpQtySaveRec = () => {
        setShowWait(true)
        setshowButton(false)
        setError("d_disp_Error_msg", {message: ""});
        ;

        console.log("onMakeUpQtySaveRec data", Data);
        (async () => {
            try {
                const res = await gsb.post('/fbs/Master', {
                    sb_data: Data, 
                    cPgmId: "OpenPos",
                    cAction: "PositionMakeupValidate",
                })                
                if ( res.data.ok ) {
                    const res2 = await gsb.post('/fbs/Master', {
                        sb_data: Data, 
                        cPgmId: "OpenPos",
                        cAction: "PositionMakeupSave",
                    })                
                    if ( res2.data.ok ) {
                        utils.showSuccess(res2.data.data)
                    } else {
                        utils.showWarn(res2.data.data)
                    }
                } else {
                    utils.showWarn(res.data.data2)
                    setshowButton(true)
                    for (let j = 0; j < res.data.data.length; j++) {
                      
                        setError(res.data.data[j][0], {
                           message: res.data.data[j][1]
                        }); 
                    }
                }
            } catch (error) {
                utils.showError(error)
            }
        })()
        setShowWait(false)
    }


    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    const showError = (err: any) => {
        if (err.response) {
            toaster.show({ message: err.response.data.description, intent: Intent.WARNING })
        } else if (err.request) {
            toaster.show({ message: "Request failed", intent: Intent.WARNING })
        } else {
            toaster.show({ message: err.message, intent: Intent.WARNING })
        }
    }

    const showSuccess = (message: string) => {
        toaster.show({ message: message, intent: Intent.SUCCESS })
    }


    function PageNo(n: number) {
        if (n > 0 ) {
            if ( nPage+n <= nTotalPage ) {
                setnPage(nPage+n)
            }
        } else
        {
            if ( nPage+n > 0 ) {
                setnPage(nPage+n)
            }
        }
        return null;
    }

    let Pagination = <>
        <div className="Row">
            <FormGroup className="Col-1-12" label="">
                Page &nbsp;
                { (nTotalPage > 1) &&
                    <span id="RPageNo2" onClick={() =>PageNo(-1)}> &laquo; &nbsp; </span>
                }
                { (nTotalPage > 1) && (nPage != 1) && 
                    <span id="RPageNo2" onClick={() => setnPage(1)}> {1} </span>
                }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage-10) && (j+1 < nPage) && (j+1 != 1) && <span id="RPageNo2" onClick={() => setnPage(no.n)}> {no.n} </span>
                )}
                { (nTotalPage >= 1) && <span > {nPage} </span> }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage) && (j+1 < nPage+10) && (j+1 != nTotalPage) && <span id="RPageNo2" onClick={() => setnPage(no.n)}> {no.n} </span>
                )}
                { (nTotalPage > 1) && (nPage != nTotalPage) && 
                    <span id="RPageNo2" onClick={() => setnPage(nTotalPage)}> &nbsp; {nTotalPage} </span>
                }
                { (nTotalPage > 1) &&
                    <span id="RPageNo2" onClick={() =>PageNo(+1)}> &nbsp; &raquo; </span>
                }
            </FormGroup>
        </div>
    </>

    
    let list = <>
        <div className="Row">
            <Button disabled={true} className="Col-1-1" icon="add" onClick={() => { setCurrentMode("new") }}>New</Button>
            <Button disabled={! showButton} className="Col-2-1" icon="confirm" onClick={() => { onMakeUpQtySaveRec() } }>Save</Button> 
        </div>
        <div className="Spacing-V-16" />
        {ShowWait && <div>{imgWait}</div> }
        {nPage > 0 && Pagination}
        {errors.d_disp_Error_msg && errors.d_disp_Error_msg.types && <span id="Err_msg">{errors.d_disp_Error_msg.types.message}</span>} 
        <HTMLTable striped interactive condensed>
            <thead>
                <th className="TCol-Seq_No">Seq No.</th>
                <th className="TCol-StkNo">Comdy</th>
                <th className="TCol-Price">Trade Price</th>
                <th className="TCol-Qty">Long Position</th>
                <th className="TCol-Qty">Short Position</th>
                <th className="TCol-Qty">Makeup Qty</th>
                <th className="TCol-Date">Trade Date</th>
            </thead>
            <tbody id="ma_tr">
                {Data.map((MakeUp, i) =>
                    <tr key={i} onDoubleClick={() => { } }>
                        <td className="TCol-Seq_No" onClick={() => { } }>{MakeUp.d_Seq}</td>
                        <td className="TCol-StkNo" onClick={() => { } }>{MakeUp.d_Comdy}</td>
                        <td className="TCol-Price" onClick={() => { } }>{MakeUp.d_Price}</td>
                        {MakeUp.d_BSType == "B" && <td className="TCol-Qty" onClick={() => { } }>{utils.formatNumber2(MakeUp.d_Qty)}</td> }
                        {MakeUp.d_BSType == "B" && <td className="TCol-Qty" onClick={() => { } }></td> }
                        {MakeUp.d_BSType == "S" && <td className="TCol-Qty" onClick={() => { } }></td> }
                        {MakeUp.d_BSType == "S" && <td className="TCol-Qty" onClick={() => { } }>{utils.formatNumber2(MakeUp.d_Qty)}</td> }
                        <td className="TCol-Qty"><InputGroup className="inputNumberNoSpin" id="inputMakeUpQty" defaultValue={MakeUp.d_MkQty} onChange={utils.handleStringChange(s => onChangeMakeUpQty(MakeUp._recordNo, s ))} /></td>
                        <td className="TCol-Date" onClick={() => { } }>{utils.dispDate(MakeUp.d_ODate, GsbFlag.dateFormat)}</td>
                    </tr>
                )}
            </tbody>
        </HTMLTable>
        {ShowWait && nTotalPage > 0 && <div>{imgWait}</div> }
        {nPage > 0 && Pagination}
    </>


    let CoHead = <SystemHeader companyLogo={companyLogoName} companyName={CO_NAME} dataPath={SBPath} tradeDate={TRAN_DATE} settlementDate={SETL_DATE}></SystemHeader>
    return (
        <>
            <FBSClientPicker gsb={gsb} isOpen={isClPickerOpen} onClose={()=>setIsClPickerOpen(false)} onSelect={(ac)=>{sets_AcCodeValue(ac.d_Acct); setIsClPickerOpen(false)}}/>
            <form onSubmit={onSubmit}>
                <div className="Spacing-V-Menu"></div>                
                <div className="Row">
                    <FormGroup className="Col-1-12"  >
                        {CoHead}
                    </FormGroup>
                </div>
                <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                    <div>
                        <H3>Position Makeup</H3>
                    </div>
                    <div className="Spacing-V-16" />
                    <div className="Row">
                        <FormGroup className="Col-1-1" label="Account No." labelFor="inputacCode" labelInfo="*">
                            <InputGroup id="inputacCode" name="d_Acct" value={s_AcCodeValue} autoFocus placeholder="Account No. ..." onChange={utils.handleStringChange(s => sets_AcCodeValue(s.toUpperCase()))} inputRef={register({ required: true , maxLength: acNoLength}) } 
                                rightElement={<Button icon="double-chevron-down" minimal onClick={() => {setIsClPickerOpen(true)}}></Button>}
                            />
                        </FormGroup>
                        <FormGroup className="Col-2-3" label="Account Name">
                            <div id="DispText">{AcName1Value}</div>
                            <div id="DispText">{AcName2Value}</div>
                        </FormGroup>
                    </div>
                    <div className="Row">
                        <FormGroup className="Col-1-1" label="Commodity" labelFor="inputComdy" labelInfo="*">
                            <InputGroup id="inputComdy" name="d_Comdy" value={s_ComdyValue} placeholder="Commodity ..." onChange={utils.handleStringChange(s => sets_ComdyValue(s.toUpperCase()))} inputRef={register({ required: true , maxLength: 5}) } />
                        </FormGroup>
                        <FormGroup className="Col-3-3" label="Commodity Name" labelFor="inputComdyName">
                            <div>
                            <div id="DispText">{ComdyNameValue}</div>
                            </div>
                        </FormGroup>
                        <FormGroup className="Col-6-2" label="Exchange">
                            <div>
                            <div id="DispText">{MarketValue}</div>
                            </div>
                        </FormGroup>
                    </div>
                    <div className="Row">
                        <FormGroup className="Col3-1-1" label="Call / Put" labelFor="inputCallPut">
                            <HTMLSelect id="inputCallPut" fill
                                value={s_CallPutValue} 
                                onChange={utils.handleStringChange(s => sets_CallPutValue(s)) }
                                elementRef={register}
                            >
                                <option value=""></option>
                                <option value="C">{utils.fbsCallPutTypeName("C")}</option>
                                <option value="P">{utils.fbsCallPutTypeName("P")}</option>
                            </HTMLSelect>
                        </FormGroup>
                    </div>
                    <div className="Row">
                        <FormGroup className="Col-1-1" label="Expiry Month" labelFor="inputDMon" >
                            <InputGroup id="inputDMon" name="d_DMon" value={s_DMonValue} placeholder="Expiry Month ..." onChange={utils.handleStringChange(s => sets_DMonValue(s.toUpperCase())) } inputRef={register({ maxLength: 7}) } />
                        </FormGroup>
                    </div>
                    <div className="Row">
                        <FormGroup className="Col-1-1" label="Strike Price" labelFor="inputStrike">
                            <InputGroup id="inputStrike" name="d_Strike" value={s_StrikePriceValue} placeholder="Strike Price ..." onChange={utils.handleStringChange(s => sets_StrikePriceValue(s.toUpperCase()))} inputRef={register} />
                        </FormGroup>
                    </div>
                    <div className="Spacing-V-16" />
                    <div className="Row">
                        <Button disabled={! ShowOK} type="submit">Search</Button>
                    </div>
                    <div className="Spacing-V-16" />
                    {ShowWait && <div className="TCol-Progress2">Progress ...</div> }
                    {ShowWait && <div className="TCol-Progress2"><ProgressBar stripes={false} animate={false} value={ProgressValue} /></div> }

                    {ShowNoRecord && <p>
                        <div className="Spacing-V-16" />
                        <div className="Row">
                            <FormGroup className="Col-1-3"  >
                                <span id="Err_msg">No Record found !!!</span>
                            </FormGroup>
                        </div>
                    </p>
                    }
                    {ShowRst && list}
                    <div className="Spacing-V-16" />
                </Card>
            </form>
        </>
    );
}

export default PositionMakeupMain